<template>
   
        <!-- pie -->

                    <v-layout row justify-center>
                        <section>
                            <svg viewBox="0 0 180 180" class="circle-chart pie-size" xmlns="http://www.w3.org/2000/svg">
                            <circle  class="circle-chart__background" stroke="rgb(16,25,43)" stroke-width="10" fill="none" cx="89.618" cy="89.618" r="79.618" />
                            
                            <!-- +30 to actual radius and +20 again to total radius for cs and cy and +250 total score and +250 to score -->
                            <circle  class="circle-chart__circle " stroke="rgb(3,119,188)" stroke-width="10" :stroke-dasharray="scoreTotal+',500'" stroke-linecap="round" fill="none" cx="89.618" cy="89.618" r="79.618" />
                         
                                 <!-- <text class="circle-chart__percent text-h3 font-weight-bold" x="90.618" y="80.5" alignment-baseline="central" text-anchor="middle" >  {{StudentData.totalScore}} </text>
                                <text class="circle-chart__percent text-h6 font-weight-medium" x="100.618" y="115.5" alignment-baseline="central" text-anchor="middle">/500</text> -->
                        
                            </svg>
                            
                        </section>
                        <div class=" ml-n16 mt-16">
                            <div class="ml-n16 mt-lg-16 mt-10">
                                 <div class="ml-n16">

                                     <div class="ml-lg-n12 ml-n4">
                                            <span class="text-h2 font-weight-bold ml-4 monsterrat"> {{scoreTotal}} </span>
                                            <br>
                                            <div class="text-h4 ml-9 mt-1 monsterrat"> /500 </div>
                                    </div>
                                 
                                </div>
                            </div>
                           
                        </div>

                        


                    </v-layout>

               

        <!-- pie -->
                  
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    name: 'PieChartNew',
    props:['scoreTotal'],
    data:()=>{
        return{
            StudentData: '',
        }
    },
    mounted(){
     
        axios.get('https://phone.megatalking.com/origin/api/leveltest_evaluation.php?l_id='+this.$route.params.l_id+'&action=levelResult')
        // .then(response=>console.warn(response.data))
        .then((response)=>{this.StudentData=response.data, this.word1=response.data.feedBack.word[0]})
        // this.word1()
        // this.word2()
       
    },
}
</script>
<style scoped>
@import '../../../../src/assets/css/LevelTest/Forms/pieChartnew.css';
</style>
<style scoped>
.monsterrat {
    font-family: 'Montserrat', serif !important;
}
</style>